import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import companyServices from '../companyServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import AwsImageInline from '../../../../../components/InlineEdit/AwsImageInline';


function CompanyForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {        
        companyName:"",
        gst:"",
        city:"",
        state:"",
        address:"",
        zip:"",
        phone:"",
        email:"",

        pan:"",
        bankName:"",
        bankAccountHolderName:"",
        bankAccountNumber:"",
        bankBranch:"",
        bankIfsc:"",
        bankSwift:"",
        
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            companyName:data.companyName,
            gst:data.gst,
            city:data.city,
            state:data.state,
            address:data.address,
            zip:data.zip,
            phone:data.phone,
            email:data.email,


            pan:data.pan,
            bankName:data.bankName,
            bankAccountHolderName:data.bankAccountHolderName,
            bankAccountNumber:data.bankAccountNumber,
            bankBranch:data.bankBranch,
            bankIfsc:data.bankIfsc,
            bankSwift:data.bankSwift,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        companyName:Yup.string().required("Required"),
        city:Yup.string().required("Required"),
        phone:Yup.string().matches(/^[0-9]+$/, "Phone number must contain only digits").length(10, "Phone number must be exactly 10 digits").required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        companyServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Company</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Company"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Company Name" name="companyName" 
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="GST #" name="gst" 
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Phone" name="phone" 
                                                    />
                                                </div>
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Email" name="email"   
                                                    />
                                                </div>

                                                <hr className='my-3' />
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="City" name="city"   
                                                    />
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="State" name="state"  
                                                        options={masters['indian-state']} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Pincode" name="zip"   
                                                    />
                                                </div>

                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Address" name="address"   
                                                    />
                                                </div>

                                                <hr/>

                                                <div className='col-md-12'>
                                                    <h4>Bank Account Details</h4>
                                                </div>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Company Pan" name="pan"   
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Company Bank Name" name="bankName"   
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Account Holder Name" name="bankAccountHolderName"
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Bank Account Number" name="bankAccountNumber"
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Bank Branch Name" name="bankBranch"
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Bank IFSC Code" name="bankIfsc"
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Bank Swift Code" name="bankSwift"
                                                    />
                                                </div>


                                            </div>

                                            {data &&
                                            <div className='row'>
                                                    <div className='col-md-6'>
                                                        <h3>Company Logo</h3>
                                                        <AwsImageInline
                                                            label="Company Logo"
                                                            name="logo"
                                                            value={data.logo}
                                                            editId={data.id}
                                                            save={companyServices.save}
                                                            updateInline={null}
                                                            path="company/logo"
                                                            fileId={"logo"}
                                                            onSuccess={()=>{}}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <h3>Company Authorization</h3>
                                                        <AwsImageInline
                                                            label="Auth Sign"
                                                            name="authSign"
                                                            value={data.authSign}
                                                            editId={data.id}
                                                            save={companyServices.save}
                                                            updateInline={null}
                                                            path="company/auth"
                                                            fileId={"authSign"}
                                                            onSuccess={()=>{}}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default CompanyForm